module.exports = __webpack_public_path__ + "dc3ac7180cac3a436af79d237607f62c.png";